<template>
    <span :class="spanClass">{{label}}</span>
</template>

<script>
    export default {
        name: "Label",
        props: {
            label: {
              type: String,
            },
            required: {
                type: Boolean,
            }
        },
        computed: {
            spanClass() {
                const classNm = this.required ? 'required' : '';
                return classNm;
            }
        }
    }
</script>

<style scoped>
    .required::before {
        content: "*";
        color: red;
        margin-right: 4px;
    }
</style>